import "./archive-page-content.scss";

import { ReactNode } from "react";
import {
  Pagination,
  PaginationProps,
} from "design-system/components/primitives/pagination/pagination";

export interface ArchivePageContentProps {
  children: ReactNode;
  aside: ReactNode;
  pagination?: PaginationProps;
  searchPagination?: ReactNode;
  rightRail?: ReactNode;
}

export function ArchivePageContent({
  children,
  aside,
  pagination,
  searchPagination,
  rightRail,
}: ArchivePageContentProps) {
  return (
    <div>
      <div className="hbs-archive-page-content__wrapper">
        <div className="hbs-archive-page-content">
          <aside className="hbs-archive-page-content__aside-wrapper">
            <div className="hbs-archive-page-content__aside">{aside}</div>
          </aside>
          <div className="hbs-archive-page-content__main">
            <section className="hbs-archive-page-content__children">
              {children}
            </section>
          </div>
          {rightRail && (
            <aside className="hbs-aside-wrapper hbs-aside-right">
              {rightRail}
            </aside>
          )}
        </div>
      </div>
      {pagination && (
        <div className="hbs-archive-page-content__pagination">
          <Pagination {...pagination} />
        </div>
      )}
      {searchPagination && (
        <div className="hbs-archive-page-content__pagination">
          {searchPagination}
        </div>
      )}
    </div>
  );
}
